export default [
  {
    path: '/food',
    name: 'food-read',
    component: () => import('@/views/food/food-list/FoodList.vue'),
    meta: {
      resource: 'Food',
      action: 'read',
    },
  },
  {
    path: '/food/create',
    name: 'food-create',
    component: () => import('@/views/food/food-form/FoodForm.vue'),
    meta: {
      resource: 'Food',
      action: 'create',
    },
  },
  {
    path: '/food-category',
    name: 'food-category-read',
    component: () => import('@/views/food/category-list/CategoryList.vue'),
    meta: {
      resource: 'Food Categories',
      action: 'read',
    },
  },
  {
    path: '/food-category/create',
    name: 'food-category-create',
    component: () => import('@/views/food/category-list/CategoryForm.vue'),
    meta: {
      resource: 'Food Categories',
      action: 'create',
    },
  },
  {
    path: '/food-sub-category',
    name: 'food-sub-category-read',
    component: () => import('@/views/food/sub-category-list/SubCategoryList.vue'),
    meta: {
      resource: 'Food Sub Categories',
      action: 'read',
    },
  },
  {
    path: '/food-category/create',
    name: 'food-category-create',
    component: () => import('@/views/food/sub-category-list/SubCategoryForm.vue'),
    meta: {
      resource: 'Food Sub Categories',
      action: 'create',
    },
  },
  {
    path: '/food-allergy',
    name: 'food-allergy-read',
    component: () => import('@/views/food/allergy-list/AllergyList.vue'),
    meta: {
      resource: 'Food Allergies',
      action: 'read',
    },
  },
  {
    path: '/food-allergy/create',
    name: 'food-allergy-create',
    component: () => import('@/views/food/allergy-list/AllergyForm.vue'),
    meta: {
      resource: 'Food Allergies',
      action: 'create',
    },
  }
]